export const VirtualQR = {
    GET_VIRTUALQRUSERSECTION: "GET_VIRTUALQRUSERSECTION",
    GET_ALLVIRTUALQRCODES: "GET_ALLVIRTUALQRCODES"
    


}
